module.exports = __webpack_public_path__ + "static/media/sandwich-image-2.24b94905.png";